import en from './locales/en.json';
import de from './locales/de.json';

export const transactionDetailsLocales = {
  en: { transactionDetails: en },
  de: { transactionDetails: de },
};

export { default as TransactionDetailsDialog } from './components/TransactionDetailsDialog.vue';
export * from './transaction-details.types';
export * from './transaction-details.adapter';
